export class PurchaseRequisitionApproveDeclineReworkCompletionData {
    private readonly selectedApprover: string | undefined;

    constructor(selectedApprover?: string) {
        this.selectedApprover = selectedApprover;
    }
}
